<template>
    <Layout>
    <PageHeader :title="title" :items="items" />
    
    
    <!-- Div principal listagem de transferencia -->
    <div v-if="mostrarLista" class="principal-lista">
        
        <b-row>
            <b-col cols="12">
                <b-card  title="Lista de bloqueios" class="md-2" >
                    <b-row>
                        <div>
                            <b-overlay
                                :show="loading"
                                rounded
                                opacity="0.6"
                                spinner-small
                                spinner-variant="success"
                                class="d-inline-block"
                                @hidden="onHidden"
                                >
                                    <b-button class="float-end" block 
                                        @click="iniciar"
                                        variant="success"
                                        :disabled="loading"
                                        ref="botao_iniciar"
                                    >
                                        Atualizar
                                    </b-button>
                                    <!-- <b-button
                                        ref="botao_iniciar"
                                        :disabled="loading"
                                        variant="primary"
                                        @click="iniciar"
                                    >
                                        Atualizar
                                    </b-button> -->
                            </b-overlay>
                        </div>
                        <b-table
                        
                            stacked="sm"
                            label-sort-asc=""
                            label-sort-desc=""
                            label-sort-clear=""
                            dense
                            striped
                            hover
                            :items="itensBloqueados"
                            :fields="fieldsItensBloqueados"
                            primary-key="id"
                            small
                            sticky-header
                            head-variant="dark"
                            responsive="sm"
                            :busy="loading"
                            show-empty
                            emptyText="Não existe dados cadastrados"
                            emptyFilteredText="Nenhum registro encontrado"
                            foot-clone
                        >

                        <template v-slot:cell(preco_vendido)="row">
                                <input 
                                    type="number" 
                                    v-model="row.item.preco_vendido"
                                    style="width:100px; text-align: right;"
                                >
                            </template>

                        <template v-slot:cell(acoes)="row">
                            <b-button v-if="row.item.bloqueado==false" variant="success" @click="liberar(row.item)">
                                <b-icon icon="unlock-fill" size="lg" class="mr-5" ></b-icon>
                                Liberado
                            </b-button>
                            <b-button v-else variant="danger" @click="liberar(row.item)">
                                <b-icon icon="lock-fill" size="lg" class="mr-5" ></b-icon>
                                Liberar
                            </b-button>
                            <!-- <b-icon icon="trash" size="sm" @click="apagar(row.item)"></b-icon> -->
                        </template>
                            
                        </b-table>
                    </b-row>

                    <!-- digitar o produto -->
                    <b-row>

                    </b-row>


                    

                </b-card>
            </b-col>
        </b-row>
        <!-- <b-button class="float-end" block 
                                        @click="automatico"
                                        variant="success"
                                        :disabled="loading"
                                        ref="botao_iniciar"
                                    >
                                        Atualizar
                                    </b-button> -->
    </div>







    </Layout>
    
</template>





<script>
//import Multiselect from "vue-multiselect";


import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

import { ApiFac} from './ApiFac'
import { ApiInv} from '../inv/ApiInv'
import { ApiCmp} from '../cmp/ApiCmp'

import mensagemMixin from "@/mixins/mensagensMixin.js";
import moment from "moment";

//import jsPDF from 'jspdf'
//import html2canvas from 'html2canvas'

export default {
    name: "Bloqueio",
    //components: {Layout,  PageHeader, Multiselect },
    components: {Layout,  PageHeader },
    mixins:[mensagemMixin],
    data() {
        return {
            title: "Bloqueio de mercadoria",
            items: [
                {
                    text: "Dashboard",
                    href: "/home",
                },
                {
                    text: "Bloqueio",
                    active: true,
                },
            ],
            api: new ApiFac(),
            ApiInv: new ApiInv(),
            ApiCmp: new ApiCmp(),
            mostrarLista:true,
            botaoGravar:true,
            itensBloqueados:[],
            //dataInicial:'01/05/2022',
            //dataFinal:'26/05/2022',
            //dataInicial: new Date().toISOString().substring(0,10),
            //dataFinal: new Date().toISOString().substring(0,10),
            dataInicial: new Date().toLocaleDateString(),
            dataFinal: new Date().toLocaleDateString(),
            loading:false,
            oldValue:0,
            newValue:0,
            fieldsItensBloqueados: [
                //{ key: "id", label: "ID", sortable: true },
                { key: "codigo_bloqueio", label: "Pedido", sortable: true },
                { key: "produto.id", label: "Código", sortable: true },
                { key: "produto.descricao", label: "Código", sortable: true },
                { key: "preco_venda", label: "Preço Venda", sortable: true },
                { key: "preco_custo", label: "Preço Custo", sortable: true },
                { key: "preco_vendido", label: "Preço Vendido", sortable: true },
                //{ key: "destino", label: "Empresa destino", sortable: true },
                { key: "uc.username", label: "Usuário:", sortable: true },
                { key: "um.username", label: "Liberado por:", sortable: true },
                //{ key: "total", label: "Total", sortable: true, formatter:(value) =>{return value.toFixed(2)} },
                { key: "acoes", label: "Ações" },
            ],
            empresa:null,
            intervaloID : null,
        };
    },
    mounted() {
        if((localStorage.getItem("empresa") !== 'undefined') && (localStorage.getItem("empresa") !== null)){
            this.empresa = JSON.parse(localStorage.getItem("empresa"))
    } else {
        this.mensagem("Selecione uma empresa!", "Atenção", "warning") //mixin
      this.empresa = {}
      this.$router.push('/empresas')
    }
        
        this.iniciar()

        this.automatico()

        
    },
    computed: {
    },
    destroyed(){
        this.pararIntervalo()
    },
    methods:{
        onHidden() {
            // Return focus to the button once hidden
            this.$refs.botao_iniciar.focus()
        },
        async iniciar(){
            try {
                this.loading = true
                await this.iniciarLista()
                this.numero_tr = -1
                this.loading = false
            } catch (error) {
                console.log(error)                
                this.loading = false
            } finally {
                this.loading = false
            }
        },
        async iniciarLista(){
            //let dataInicial = moment(this.dataInicial, "DD/MM/YYYY").format("YYYY-MM-DD");
            //let dataFinal = moment(this.dataFinal, "DD/MM/YYYY").format("YYYY-MM-DD");
            //let empresa = this.empresa.id

            //this.loading = true
            let bloqueados = await this.api.getBloqueio()

            console.log(bloqueados)

            console.log(bloqueados.status)

            if(bloqueados.status === 401){
                this.$router.push("/login")
                return false
            }

            this.itensBloqueados = bloqueados
                /* 
        },
        /* 
         async cancelar(obj){
            if(await this.mensagemPergunta(`Cancelar a transferência ${obj.item.id}`, 'Confirme!')){
                console.log(obj.item.id)

            }
        },
        */
        },
        async liberar(item){
            //alert(item.codigo_bloqueio)
            console.log(item.id)
            console.log(item.codigo_bloqueio)
            console.log(item.preco_vendido)

            const cabecalho = {
                id: item.id,
                codigo_bloqueio: item.codigo_bloqueio,
                preco_vendido: item.preco_vendido,
                liberado: true,
                produto_id: item.produto.id,
            }

            const obj = new FormData()
            for (const key in cabecalho){
                obj.append(key, cabecalho[key])
            }

            const resposta = await this.api.desbloquearVenda(obj)
            console.log(resposta)
            console.log(resposta.data)


            if (resposta.status == 200) {
                this.$toastr.s(`Liberado`);
                item.bloqueado = false
                item.um.username = resposta.data.um.username
            }else{
                if(resposta.data.detail){
                    this.$toastr.e(resposta.data.detail);
                } else {
                    this.$toastr.e(`Não funcionou`);
                }


            }


        },
        async gravar(){
            let dataTransferencia_ptBr =  new Date().toLocaleDateString()
            let dataTransferencia = moment(dataTransferencia_ptBr, "DD/MM/YYYY").format("YYYY-MM-DD")
            console.log(dataTransferencia)
            

            const enc = {
                id: this.numero_tr,
                produtos: JSON.stringify(this.produtos)
            }
            const obj = new FormData()
            for (const key in enc){
                obj.append(key, enc[key])
            }
            const venda = await this.api.saveVenda(obj)
            console.log(venda)
            if(venda.data.id){
                //this.mensagem("Transferência feita com sucesso", "Gravou", "success")
                
                this.numero_tr = venda.data.id
                this.usuarioCriador = venda.data.uc.username
                this.$toastr.s(`Transferência feita com sucesso!`);
            } else {
                this.botaoGravar = true
                if(venda.data.detail){
                    this.mensagem(venda.data.detail, "Atenção", "error")
                } else{
                    this.mensagem("Erro ao gravar a Entrada"+venda.statusText, "Atenção", "error")
                    //bla bla
                }
                console.log("Erro: ",  venda)
                //this.mensagem("Erro ao gravar a Transferência", "Erro", "error")
                return false
                

            }






        },

        automatico(){
            this.intervaloID = setInterval(()=>{
                console.clear()
                console.log("Executando método automatico")
                this.iniciar()
            }, 15000)
        },
        pararIntervalo(){
            clearInterval(this.intervaloID)
            this.intervaloID = null
        }
        

    },
    
};
</script>




<style>
.container-botao{
    display: flex;
    justify-content: flex-start;
}

.container-botao .icone{
    margin-right: 15px;
}

.produto-container{
    position: relative;
}

.limpa-detalhe{
    position: absolute;
    bottom: 0px;
    left: 15px;
    font-size: 10px;
}
.limpa-detalhe:hover{
    cursor: pointer;
}
.limpa-detalhe i{
    font-size: 1.5em;
    bottom: 0px;
}




/* BOTÃO */
@media (max-width:767px) {
    .container-botao{
        min-height: 15vh;
    }
    .limpar{
        align-items: center;
        justify-content: start;
       
    }
    .gravar{
        align-items: center;
    }
}

@media (min-width:768px) {

    .container-botao{
        min-height: 8vh;
    }
}

.container-botao-old{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;


    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #27282c;

    flex-direction: column;
    /* gap: 60px; */
}



.container-botao a{
    position: relative;
    background: #444;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1.5em;
    letter-spacing: 0.1em;
    padding: 10px 25px;
    transition: 0.5s;
}

.container-botao a:hover{
    letter-spacing: 0.25em;
    background: var(--clr);
    color: var(--clr);
    box-shadow: 0 0 35px var(--clr);
}

.container-botao a::before{
    content: '';
    position: absolute;
    inset: 2px;
    background: #27282c;
}

.container-botao a span{
    position: relative;
    z-index: 1;
}

.container-botao a i{
    position: absolute;
    inset: 0;
    display: block;
}

.container-botao a i::before{
    content: '';
    position: absolute;
    top: -2px;
    left: 80%;
    width: 10px;
    height: 8px;
    border: 2px solid var(--clr);
    background: #27282c;
    transform: translateX(-50%);
    transition: 0.5s;
}

.container-botao a:hover i::before{
    width: 20px;
    left: 20%;
}

.container-botao a i::after{
    content: '';
    position: absolute;
    bottom: -2px;
    left: 20%;
    width: 10px;
    height: 8px;
    border: 2px solid var(--clr);
    background: #27282c;
    transform: translateX(-50%);
    transition: 0.5s;
}

.container-botao a:hover i::after{
    width: 20px;
    left: 80%;
}

/* END BOTÃO */
    .print-loja{
        font-size: 2em;
        text-align: center;
        width: 300px;
        display: inline-block;
    }

    .print-para{
        margin-left: 10px;
    }

    .print-titulo{
        margin-left: 50px;
    }

    .print-destino{
        font-size: 1.5em;
        margin-left: 0px;
    }

    .print-label-descricao{
        font-weight: bold;
        margin-left: 10px;
    }

    .print-label-quantidade{
        font-weight: bold;
        margin-left: 55px;
    }

    .print-label-preco{
        font-weight: bold;
        margin-left: 45px;
    }

    .print-label-subtotal{
        font-weight: bold;
        margin-left: 25px;
        
    }


    .print-descricao{
        font-weight: bold;
        margin-left: 10px;
    }
    .print-codigo{
        width: 60px;
        margin-left: 10px ;
        /* border: solid 1px black; */
        display: inline-block;
    }
    .print-quantidade{
        width: 10px;
        margin-left: 10px;
        /* border: solid 1px black; */
        display: inline-block;
        text-align: center;
    }
    .print-preco{
        width: 50px;
        margin-left: 20px;
        /* border: solid 1px black; */
        text-align: end;
        display: inline-block;
    }
    .print-subtotal{
        width: 100px;
        margin-left: 00px;
        text-align: end;
        /* border: solid 1px black; */
        display: inline-block;
    }
    .print-total{
        font-weight: bold;
        margin-left: 120px;
        font-size: 1.5em;
    }

    .print-botao-imprimir{
        margin-right: 5px;
    }
    @media print {
        .print-botao-imprimir{
            display: none;
        }
        #app{
            /* display:none */
        }
        .area-impressao{
            display: block;
        }
    }
</style>